import { AxiosError } from 'axios';
import { isPlainObject } from 'lodash';

export type RejectedPayload = {
  message: string;
  name: string;
  httpCode: number | null;
};

// Construct a reject payload for various kinds of error responses
export const constructRejectedPayload = (error: Error): RejectedPayload => {
  // Normal case with JSON response body
  if (error instanceof AxiosError && error.response && isPlainObject(error.response.data))
    return { ...error.response.data, httpCode: error.response.status };
  // HTML or text response body is ignored
  // In that case, we just use the statusText
  else if (error instanceof AxiosError && error.response)
    return {
      message: error.response.status + ' ' + error.response.statusText,
      name: 'http-error-response',
      httpCode: error.response.status,
    };
  // Client-side (non-axios) error
  else if (error instanceof Error)
    return { message: error.message, name: error?.name || 'unknown-error', httpCode: null };
  return { message: 'Unknown Teacher Dashboard Error', name: 'unknown-error', httpCode: null };
};
